module.exports = __webpack_public_path__ + "img/Sedan_Back_Side_Right.cd870b13.svg";